module.exports = __webpack_public_path__ + "media/images/nc_icon-7d038af124808e1185b7ab619df9243d.svg";